import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_INSTITUTIONITEMCATEGORIES_LOAD_BY_INSTITUTIONID,
    IInstitutionItemCategoriesLoadByInstitutionIdAction,
    IInstitutionItemCategoriesLoadByInstitutionIdFailureAction,
    IInstitutionItemCategoriesLoadByInstitutionIdSuccessAction,
    LoadFailure,
    LoadSuccess,
} from "../actions/institutionItemCategory";
import { institutionItemCategoryApi } from 'src/services/institutionItemCategory';

export const
    getInstitutionItemCategoriesByInstitutionIdEpic = (action$): Observable<IInstitutionItemCategoriesLoadByInstitutionIdSuccessAction | IInstitutionItemCategoriesLoadByInstitutionIdFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONITEMCATEGORIES_LOAD_BY_INSTITUTIONID)
            .mergeMap((action: IInstitutionItemCategoriesLoadByInstitutionIdAction) => {
                return institutionItemCategoryApi
                    .getInstitutionItemCategoriesByInstitutionId(action.institutionId)
                    .map(response =>
                        LoadSuccess(response.institutionItemCategories, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    }